module.exports = __webpack_public_path__ + "img/730112caa3267520a33962d055893b5c.png";